import { Moment } from 'moment';
import { formatValueDateToMoment } from '../../../components/helpers/formatValueDateToMoment';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const isValueDateInCurrentMonth = (
  date: values.v1.Date,
  currentDate: Moment
): boolean => {
  const givenDate = formatValueDateToMoment(date);
  return currentDate.isSame(givenDate, 'month');
};
